import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarArticuloComanda = ({ show, onClose, comandaId, onArticuloAgregado }) => {
    const [nuevoArticulo, setNuevoArticulo] = useState({
        articulo_menu_id: "",
        cantidad: "",
        precio: ""
    });

    // Función para manejar el cambio de los campos del formulario
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNuevoArticulo({ ...nuevoArticulo, [name]: value });
    };

    // Función para manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar si todos los campos están completos
        if (nuevoArticulo.articulo_menu_id.trim() === "" || nuevoArticulo.cantidad.trim() === "" || nuevoArticulo.precio.trim() === "") {
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            // Llamada a la API para agregar el artículo
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "articulos_comanda",
                comanda_id: comandaId,
                articulo_menu_id: nuevoArticulo.articulo_menu_id,
                cantidad: nuevoArticulo.cantidad,
                precio: nuevoArticulo.precio
            });

            // Limpiar el formulario y cerrar el modal si la respuesta es correcta
            setNuevoArticulo({ articulo_menu_id: "", cantidad: "", precio: "" });
            onArticuloAgregado(); // Actualiza la lista de artículos
            onClose(); // Cierra el modal
        } catch (error) {
            console.error("Error al agregar el artículo:", error);
        }
    };

    // Si el modal no debe mostrarse, no renderizamos nada
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Artículo</h2>

                <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
                    <div>
                        <label htmlFor="articulo_menu_id" className="block font-semibold">ID del Artículo</label>
                        <input
                            type="number"
                            id="articulo_menu_id"
                            name="articulo_menu_id"
                            value={nuevoArticulo.articulo_menu_id}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="ID del artículo en el menú"
                            maxLength={10}
                        />
                    </div>
                    <div>
                        <label htmlFor="cantidad" className="block font-semibold">Cantidad</label>
                        <input
                            type="number"
                            id="cantidad"
                            name="cantidad"
                            value={nuevoArticulo.cantidad}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Cantidad"
                            maxLength={10}
                        />
                    </div>
                    <div>
                        <label htmlFor="precio" className="block font-semibold">Precio</label>
                        <input
                            type="number"
                            id="precio"
                            name="precio"
                            value={nuevoArticulo.precio}
                            onChange={handleInputChange}
                            className="border rounded-lg p-2 w-full"
                            placeholder="Precio"
                            maxLength={10}
                        />
                    </div>

                    <div className="flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white px-4 py-2 rounded"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-green-500 text-white px-4 py-2 rounded"
                        >
                            Agregar Artículo
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarArticuloComanda;
